export const actionTypes = {
   editSample:'EDIT_SAMPLE',
   updateSamples:'UPDATE_SAMPLES',
   receiveSamples:'RECEIVE_SAMPLES',
   receiveSampleLocators:'RECEIVE_SAMPLE_LOCATORS'
};

export const editSample = (id, locator) => ({ type: actionTypes.editSample, id, locator });
export const receiveSamples = (samples) => ({ type: actionTypes.receiveSamples, samples});
export const receiveSampleLocators = (samples) => ({ type: actionTypes.receiveSampleLocators, samples});